import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
    FormGroup,
    Form
} from "reactstrap"

import { connect } from "react-redux";
import { useDispatch } from 'react-redux'

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import axios from "axios";
import { CREATE_USER_TYPE } from "helpers/url_helper";
import { createUserType } from "helpers/userTypeHelper";






const CreateUser = (props) => {
    document.title = "Question Bank | Create User";
    const [name, setName] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const result = useSelector(state => state.userReducer);
    const dispatch = useDispatch();
    const [contentAccess, setContentAccess] = useState(false);
    const [trainerAccess, setTrainerAccess] = useState(false);



    const breadcrumbItems = [
        { title: "User", link: "#" },
        { title: "Create User", link: "#" },
    ]
    useEffect(() => {           /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('Create User', breadcrumbItems)
    })


    const handleContentRights = (e) => { contentAccess === false ? setContentAccess(true) : setContentAccess(false) }
    const handleTrainerRights = (e) => { trainerAccess === false ? setTrainerAccess(true) : setTrainerAccess(false) }


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const permissions = { contentAccess, trainerAccess }
            setLoader(true)
            const data = await createUserType({ name, permissions });
            setLoader(false)
            console.log(data);
            if (data?.success) {
                toast.success(data?.message);
                setName("");
                setContentAccess(false);
                setTrainerAccess(false);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false)
            console.log(error);
        }
    }









    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col>
                    <Card>
                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Create User Type</CardTitle>
                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Name
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter User Name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)} />
                                        {!name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

                                    </div>
                                </Row>
                                <Row className="mb-3">

                                    <div className="d-flex flex-wrap">
                                        <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
                                            <label htmlFor="class_access" className="col-md-6 col-form-label">
                                                Content Managment
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    type="checkbox"
                                                    id="class_access"
                                                    name="class_access"
                                                    value={1}
                                                    onChange={handleContentRights}
                                                    checked={contentAccess ? 'checked' : ''}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
                                            <label htmlFor="class_access" className="col-md-6 col-form-label">
                                                Trainer Managment
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    type="checkbox"
                                                    id="class_access"
                                                    name="class_access"
                                                    value={1}
                                                    onChange={handleTrainerRights}
                                                    checked={trainerAccess ? 'checked' : ''}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </Row>


                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md">Submit</button>
                                    </div>
                                </Row>
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateUser);